import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/blade-resource/oss/list',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}

export const getDetail = (id) => {
    return request({
        url: '/api/blade-resource/oss/detail',
        method: 'get',
        params: {
            id
        }
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/blade-resource/oss/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-resource/oss/submit',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-resource/oss/submit',
        method: 'post',
        data: row
    })
}

export const enable = (id) => {
    return request({
        url: '/api/blade-resource/oss/enable',
        method: 'post',
        params: {
            id
        }
    })
}
export const makeBucket = (name) => {
    return request({
        url: '/api/blade-resource/oss/endpoint/make-bucket',
        method: 'post',
        params: {
            bucketName: name
        }
    })
}

export const getAttachFile = (fileName) => {
    return request({
        url: '/api/blade-resource/oss/endpoint/get-file-attach-by-name-new',
        method: 'post',
        params: {
            fileName: fileName
        },
        header: 'application/x-www-form-urlencoded',
        responseType: 'blob'
    })
}
